/**
 * Shared TanStack Query keys for entities that live in the core package and are
 * consumed across apps. App-specific keys live in each app's own
 * `src/lib/query-keys.ts` (which re-exports these under a single `queryKeys`).
 *
 * Every builder returns the exact tuple previously used inline, so cache
 * identity is unchanged.
 */
export const coreQueryKeys = {
  /** Current user's own profile — ["profile", userId] */
  profile: (userId: string | null | undefined) => ["profile", userId] as const,
  /** Current user's aggregate stats — ["user-stats", userId] */
  userStats: (userId: string | null | undefined) => ["user-stats", userId] as const,
  /** Practice categories list — ["categories"] */
  categories: () => ["categories"] as const,
} as const;
